import React from 'react';
import { CheckCircle, Award, HeartHandshake } from 'lucide-react';

const Values = () => {
  return (
    <div id="valores" className="py-16 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center">
          <div className="relative">
            <h3 className="text-2xl font-extrabold text-gray-900 tracking-tight sm:text-3xl">
              Liderazgo y Compromiso
            </h3>
            <p className="mt-3 text-lg text-gray-500">
              En ARES GLOBAL CONTROL entendemos que la imagen y la organización son pilares fundamentales. Por eso, no solo cubrimos un puesto, elevamos el estándar de su evento o instalación.
            </p>

            <dl className="mt-10 space-y-10">
              <div className="relative">
                <dt>
                  <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white">
                    <CheckCircle className="h-6 w-6" aria-hidden="true" />
                  </div>
                  <p className="ml-16 text-lg leading-6 font-medium text-gray-900">Ejecución Impecable</p>
                </dt>
                <dd className="mt-2 ml-16 text-base text-gray-500">
                  Planificamos y coordinamos cada detalle operativo. Nuestra capacidad de respuesta y organización garantizan que todo salga según lo previsto, sin improvisaciones.
                </dd>
              </div>

              <div className="relative">
                <dt>
                  <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white">
                    <Award className="h-6 w-6" aria-hidden="true" />
                  </div>
                  <p className="ml-16 text-lg leading-6 font-medium text-gray-900">Profesionales de Élite</p>
                </dt>
                <dd className="mt-2 ml-16 text-base text-gray-500">
                  La imagen importa. Nuestro personal destaca por su uniformidad impecable, trato exquisito y formación específica para resolver cualquier situación con elegancia y eficacia.
                </dd>
              </div>

              <div className="relative">
                <dt>
                  <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white">
                    <HeartHandshake className="h-6 w-6" aria-hidden="true" />
                  </div>
                  <p className="ml-16 text-lg leading-6 font-medium text-gray-900">Confianza Absoluta</p>
                </dt>
                <dd className="mt-2 ml-16 text-base text-gray-500">
                  Su tranquilidad es nuestra prioridad. Trabajamos como socios estratégicos, protegiendo sus intereses y cuidando de sus invitados como si fueran nuestros.
                </dd>
              </div>
            </dl>
          </div>

          <div className="mt-10 -mx-4 relative lg:mt-0" aria-hidden="true">
            <img
              className="relative mx-auto rounded-lg shadow-lg"
              width={490}
              src="/values-img.jpg"
              onError={(e) => {
                 e.currentTarget.src = "https://images.unsplash.com/photo-1551836022-d5d88e9218df?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80"
              }}
              alt="Equipo profesional trabajando"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Values;
